<template>
  <div
    id="plvIaLottery"
    ref="container"
    class="plv-ia-container plv-ia-lottery"
  >
    <div v-if="lotteryProcess === 'start'" class="plv-ia__lottery__start">
      <div class="plv-ia__lottery__containter">
        <div v-if="errorTipsShow" class="plv-ia-lottery__tip__error">
          {{ errorMsg }}
        </div>
        <ul class="modal-form plv-ia-modal__center__form">
          <li
            v-if="showBranch"
            class="plv-ia-modal__form__group plv-ia-modal__form__group--branch"
          >
            <div class="plv-ia-__lottery--branch">
              <span style="cursor: pointer;" @click="changeBranch">{{
                branchStatus ? t('plvIA.lottery.switchOldBranch') : t('plvIA.lottery.switchNewBranch')
              }}</span>
            </div>
          </li>
          <!-- 奖品名称 -->
          <li class="plv-ia-modal__form__group">
            <span class="plv-ia-modal__form__label">{{
              t('plvIA.lottery.prizeName')
            }}</span>
            <input
              ref="prize"
              v-model="prize"
              type="text"
              :maxlength="maxLen.prize"
              :placeholder="t('plvIA.lottery.enterPrizeName')"
              :class="[
                'plv-ia-modal__form__input',
                { 'plv-ia-wrong-input': wrongOptions.prize }
              ]"
              @click.stop="() => $refs.historyList.listShow()"
              @keyup="wrongOptions.prize = false"
            />
            <span
              class="plv-ia__prize__length"
            ><span :class="{ 'plv-ia-err': strLen(prize) > maxLen.prize }">{{
              strLen(prize)
            }}</span>/{{ maxLen.prize }}</span>
            <LotteryHistory
              ref="historyList"
              :history-prize="historyPrize"
              @get-prize="getPrize"
            />
          </li>
          <!-- 抽奖模式 -->
          <li v-show="branchStatus" class="plv-ia-modal__form__group">
            <span class="plv-ia-modal__form__label">{{
              t('plvIA.lottery.lotteryMode')
            }}</span>
            <div class="plv-ia-modal__form__select">
              <InputSelect
                :options="modeOptions"
                :default-index="modeIndex.toString()"
                :placeholder="t('plvIA.common.enter')"
                @select-index="selectMode"
              />
            </div>
          </li>
          <!-- 抽奖时间 -->
          <li
            v-show="modeIndex === 1 && branchStatus"
            class="plv-ia-modal__form__group"
          >
            <span class="plv-ia-modal__form__label">{{
              t('plvIA.lottery.luckyTime')
            }}</span>
            <el-date-picker
              v-model="luckyTime"
              style="width: 320px;"
              type="datetime"
              placeholder="请选择时间"
              :popper-class="isRestrictedWindow ? 'plv-ia-lottery-date-picker' : ''"
            />
          </li>
          <!-- 参与用户 -->
          <li class="plv-ia-modal__form__group">
            <span class="plv-ia-modal__form__label">{{
              t('plvIA.lottery.participatingUsers')
            }}</span>
            <div class="plv-ia-modal__form__select">
              <InputSelect
                :options="lotteryRangeData"
                default-index="0"
                :placeholder="t('plvIA.common.enter')"
                @select-index="selectRange"
              />
            </div>
          </li>
          <!-- 中奖人数 -->
          <li class="plv-ia-modal__form__group">
            <span class="plv-ia-modal__form__label">{{
              t('plvIA.lottery.winnersNum')
            }}</span>
            <div class="plv-ia-modal__form__input__sm">
              <InputSelect
                ref="numberSelect"
                :options="rangeNumber"
                :default-value="amount"
                :max-winners-digit="maxWinnersDigit"
                :max-winners="maxWinners"
                :could-input="true"
                width="320px"
                :placeholder="t('plvIA.lottery.enterPositiveInteger')"
                @check-input="checkNumber"
              />
            </div>
          </li>
          <!-- 预设中奖开关 -->
          <li
            v-if="!isSubsidiaryRoom"
            class="plv-ia-modal__form__group plv-ia-modal__form__group--min"
          >
            <span class="plv-ia-modal__form__label">{{
              t('plvIA.lottery.presetWinning')
            }}</span>
            <span
              :class="[
                'plv-ia-modal__switch__btn',
                { 'plv-ia-modal__switch__btn__off': switchOff }
              ]"
              @click="switchOff = !switchOff"
            ></span>
          </li>
          <!-- 预设中奖名单 -->
          <li v-show="!switchOff" class="plv-ia-modal__form__group">
            <span class="plv-ia-modal__form__label"></span>
            <div class="plv-ia__search__group fast-search">
              <input
                v-model.trim="seachUser"
                type="text"
                :placeholder="t('plvIA.lottery.quickSearch')"
                class="plv-ia-modal__form__input plv-ia-modal__form__input__preset"
                @keyup="searchLists"
              />
              <i class="plv-ia-search__icon"></i>
            </div>
          </li>
          <li>
            <div class="plv-ia__user__search__list">
              <LotteryList
                ref="lotteryList"
                :switch-off="!switchOff"
                :search-list="searchList"
                :amount="Number(amount)"
                @clear-search-input="seachUser = ''"
                @update-preset="updatePresetList"
              />
            </div>
          </li>
        </ul>
        <!-- 更多设置 -->
        <div class="plv-ia__lottery__aside__right">
          <div>
            <div class="plv-ia__lottery-collect-handle">
              <div>
                <span class="plv-ia-lottery__msg__name">{{ t('plvIA.lottery.collection') }}</span>
                <span
                  :class="[
                    'plv-ia-modal__switch__btn',
                    { 'plv-ia-modal__switch__btn__off': !collectSwitch}
                  ]"
                  @click="setCollectSwitch"
                ></span>
              </div>
              <div class="plv-ia__lottery-add-option" v-show="collectSwitch">
                <span>{{ t('plvIA.lottery.addCollectOption') }}</span>
                <div class="plv-ia__lottery-add-option-model">
                  <ul class="plv-ia__lottery-add-option-item">
                    <li v-for="(item, index) in collectBtnList"
                        :class="{'plv-ia__lottery-add-option-item--disable': item.addStatus || item.disable}"
                        :key="index"
                        @click="collectBtnControls('add', item.type)">
                      {{ item.label ||  t(item.langLabel)}}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <ul v-show="collectSwitch" class="plv-ia-lottery__msg__list__container">
              <li v-show="collectBtnList.userName.addStatus">
                <span class="plv-ia-lottery__msg__name">{{
                  t('plvIA.lottery.name')
                }}</span>
                <span class="plv-ia-lottery__msg__input">{{
                  t('plvIA.lottery.enterName')
                }}</span>
                <div class="plv-ia-lottery__options__control">
                  <span class="plv-ia-lottery__options__control-requiredText">{{ t('plvIA.lottery.requiredText') }}</span>
                  <span
                    :class="[
                      'plv-ia-modal__switch__btn',
                      { 'plv-ia-modal__switch__btn__off': !collectBtnList.userName.required }
                    ]"
                    @click="collectBtnList.userName.required = !collectBtnList.userName.required"
                  ></span>
                  <span
                    class="plv-ia-lottery__options__control__delete"
                    @click="collectBtnControls('del', collectBtnList.userName.type)"
                  ></span>
                </div>
              </li>
              <li v-show="collectBtnList.userPhone.addStatus">
                <span class="plv-ia-lottery__msg__name">{{
                  t('plvIA.lottery.phoneNum')
                }}</span>
                <span class="plv-ia-lottery__msg__input">{{
                  t('plvIA.lottery.enterPhoneNum')
                }}</span>
                <div class="plv-ia-lottery__options__control">
                  <span class="plv-ia-lottery__options__control-requiredText">{{ t('plvIA.lottery.requiredText') }}</span>
                  <span
                    :class="[
                      'plv-ia-modal__switch__btn',
                      { 'plv-ia-modal__switch__btn__off': !collectBtnList.userPhone.required }
                    ]"
                    @click="collectBtnList.userPhone.required = !collectBtnList.userPhone.required"
                  ></span>
                  <span
                    class="plv-ia-lottery__options__control__delete"
                    @click="collectBtnControls('del', collectBtnList.userPhone.type)"
                  ></span>
                </div>
              </li>
              <li
                v-for="(item, index) in collectInfo"
                :key="index"
                class="plv-ia-custom__list__input"
              >
                <span class="plv-ia-lottery__msg__name">{{
                  t('plvIA.lottery.custom')
                }}</span>
                <span class="plv-ia-lottery-collection-field">
                  <input
                    ref="field"
                    v-model="item.field"
                    :class="{
                      'plv-ia-wrong-input': wrongOptions.custom[index].field
                    }"
                    :placeholder="t('plvIA.lottery.title')"
                    type="text"
                    :maxlength="maxLen.collectionField"
                    @keyup="wrongOptions.custom[index].field = false"
                  />
                  <span
                    class="plv-ia-lottery-collection-inputlen"
                  ><span
                    :class="{
                      'plv-ia-err':
                        strLen(item.field) > maxLen.collectionField
                    }"
                  >{{ strLen(item.field) }}</span>/{{ maxLen.collectionField }}</span>
                </span>
                <span class="plv-ia-lottery-collection-tips">
                  <input
                    ref="tips"
                    v-model="item.tips"
                    type="text"
                    :maxlength="maxLen.collectionTips"
                    :class="{
                      'plv-ia-wrong-input': wrongOptions.custom[index].tips
                    }"
                    :placeholder="t('plvIA.lottery.enterDescription')"
                    @keyup="wrongOptions.custom[index].tips = false"
                  />
                  <span
                    class="plv-ia-lottery-collection-inputlen"
                  ><span
                    :class="{
                      'plv-ia-err': strLen(item.tips) > maxLen.collectionTips
                    }"
                  >{{ strLen(item.tips) }}</span>/{{ maxLen.collectionTips }}</span>
                </span>
                <div class="plv-ia-lottery__options__control">
                  <span class="plv-ia-lottery__options__control-requiredText">{{ t('plvIA.lottery.requiredText') }}</span>
                  <span
                    :class="[
                      'plv-ia-modal__switch__btn',
                      { 'plv-ia-modal__switch__btn__off': !item.required }
                    ]"
                    @click="item.required = !item.required"
                  ></span>
                  <span
                    class="plv-ia-lottery__options__control__delete"
                    @click="optionsControls('del', index)"
                  ></span>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="plv-ia__lottery-btn-group">
          <button class="plv-ia-lottery-btn" @click="startLottery">
            {{ t('plvIA.lottery.start') }}
          </button>
        </div>
      </div>
    </div>
    <Lotterying
      v-else-if="lotteryProcess === 'lotterying' && branchStatus"
      :winner-list="winnerList"
      :prize="prize"
      :lotterying="lotterying"
      :delay-time-secord="delayTimeSecord"
      :delay-status="delayStatus"
      @up-to-bottom="getWinnersList"
      @new-turn-lottery="newTurnLottery"
      @delay-end-lottery="delayEndLottery"
      @end-lottery="endLottery"
    />
    <!-- 兼容旧版本，后续更新可能删除 -->
    <LotteryingOld
      v-else-if="lotteryProcess === 'lotterying' && !branchStatus"
      :winner-list="winnerList"
      :prize="prize"
      :lotterying="lotterying"
      :no-online-users="noOnlineUsers"
      :delay-time-secord="delayTimeSecord"
      :delay-status="delayStatus"
      :fetch-over-winner="fetchOverWinner"
      @up-to-bottom="getWinnersList"
      @reset-lottery="resetLottery"
      @old-end-lottery="oldEndLottery"
    />

    <c-confirm
      ref="exceedConfirm"
      :tips="t('plvIA.lottery.exceedOnline')"
      :ensure-txt="t('plvIA.common.confirm')"
      :cancel-txt="t('plvIA.common.cancel')"
      @ensure="handleEnsureExceedConfirm"
      @cancel="handleCancelExceedConfirm"
    />
  </div>
</template>
<script>
import { strLen } from '@polyv/utils/src/string';
import Locale from '@/mixins/locale';
import InputSelect from '../../components/inputSelect';
import Lotterying from './Lotterying';
import LotteryingOld from './LotteryingOld';
import LotteryList from './LotteryList';
import LotteryHistory from './NameHistory';
import commonMixin from '../app-mixin';
import PopupConfirm from '../../components/popup/Confirm';
import { set, get } from '@polyv/utils/src/cookie.js';

export default {
  name: 'ILSLottery',

  components: {
    Lotterying,
    LotteryList,
    LotteryingOld,
    InputSelect,
    LotteryHistory,
    'c-confirm': PopupConfirm
  },
  mixins: [commonMixin, Locale],

  props: {

    /** 抽奖SDK 实例 */
    core: {
      type: Object,
      default: null
    },
    /** 是否开启新版定时抽奖 */
    delayLotteryEnable: {
      type: Boolean,
      default: false
    },
    /** 是否开启多房间 */
    isSubsidiaryRoom: {
      type: Boolean,
      default: false
    },
    /**
     * 最大中奖人数位数。
     * 如有设置 maxWinners 为非 0 整数时则忽略 maxWinnersDigit 。
     */
    maxWinnersDigit: {
      type: Number,
      default: 3
    },
    /**
     * 最大中奖人数。
     * 如有设置 maxWinners 为非 0 整数时则忽略 maxWinnersDigit 。
     */
    maxWinners: {
      type: Number,
      default: 0,
    },
    /**  直播状态 */
    liveStatus: Boolean,
    /**  是否展示 当visible改变为true时,更新抽奖状态 */
    visible: {
      type: Boolean,
      default: false
    },
    /**
     * 弹窗大小是否受限。
     * 如云直播客户端中打开抽奖时，窗口大小固定，窗口以外的内容无法显示。
     */
    isRestrictedWindow: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      DelayTimer: null, // 定时器timer
      destroyStatus: false, // 当前实例是否销毁
      modeIndex: 0, // 抽奖模式
      modeOptions: [],
      maxLen: {
        prize: 60,
        collectionField: 12,
        collectionTips: 30
      },
      luckyTime: new Date(), // 抽奖时间
      delayTime: 0, // 定时抽奖 毫秒数
      delayTimeSecord: 0, // 定时抽奖 秒
      lotteryProcess: 'start', // start: 创建抽奖界面 lotterying：抽奖动画界面
      seachUser: '',
      switchOff: true,
      errorMsg: null,
      lotteryRange: 'notWinning', // 抽奖范围
      prize: '', // 奖品名称
      amount: '', // 中奖人数
      lotteryId: '', // 抽奖ID
      historyPrize: [],
      presetList: [], // 预设中奖名单
      winnerList: [], // 中奖列表
      page: 1, // 查询中奖名单页数
      delayStatus: false, // 是否为定时抽奖状态
      totalPages: null,
      lotterying: false,
      errorTipsShow: false,
      emptyPrize: false,
      focusType: 'prize',
      showMore: false,
      searchList: [],
      rangeNumber: [
        { label: '1', value: 1 },
        { label: '2', value: 2 },
        { label: '3', value: 3 },
        { label: '4', value: 4 },
        { label: '5', value: 5 },
        { label: '6', value: 6 },
        { label: '7', value: 7 },
        { label: '8', value: 8 },
        { label: '9', value: 9 },
        { label: '10', value: 10 }
      ],
      collectInfo: [], // 自定义用户信息
      allowRequest: true, // 是否可以请求获取列表接口，避免重复请求相同内容
      noOnlineUsers: false, // 无人中奖是因为没有观众在线
      isFetchingStartApi: false, // 是否正处于调用发起抽奖接口的状态中(用于避免重复发起)
      isFetchingEndApi: false, // 是否正处于调用结束抽奖接口的状态中(用于避免重复调用结束抽奖)
      waitingFetchWinnners: false, // 是否正处于等待获取中奖名单(此时不应再允许点击结束抽奖)
      fetchOverWinner: false, // 抽奖结束后，第一次是否获取过名单（用于判断从抽奖中到获奖名单的状态）
      branchStatus: true, // 新版抽奖 旧版抽奖
      lotteryRangeData: [], // 参与用户下拉选项
      collectSwitch: true, // 是否收集用户信息
      collectBtnList: {
        userName: {
          type: 'userName',
          langLabel: 'plvIA.lottery.userName',
          addStatus: false,
          required: true
        },
        userPhone: {
          type: 'userPhone',
          langLabel: 'plvIA.lottery.userPhone',
          addStatus: false,
          required: true
        },
        custom: {
          langLabel: 'plvIA.lottery.customOption',
          type: 'custom',
          disable: false
        }
      },
      wrongOptions: {
        prize: false,
        amount: false,
        custom: [
          {
            field: false,
            tips: false
          }
        ]
      }
    };
  },
  computed: {
    showBranch() {
      // 判断是否展示新旧版，兼容旧抽奖逻辑
      return this.delayLotteryEnable;
    }
  },
  watch: {
    lang() {
      this.initOptions();
    },
    visible(newVal, oldVal) {
      if (newVal && !oldVal) {
        this.getDelayLotteryStatus();
      }
    },
    showBranch(newVal) {
      if (newVal) {
        this.branchStatus = false;
      }
    },
    seachUser() {
      this.searchLists();
    }
  },
  created() {
    this.destroyStatus = false;
    this.initOptions();
    if (!this.delayLotteryEnable) {
      this.branchStatus = false;
    }
  },
  beforeDestroy() {
    this.destroyStatus = true;
    this.clearDelayTimer();
    // 销毁事件监听,如果外部是v-if控制隐藏的话,vue实例不会被销毁掉，并且多次注册core.on()事件
    this.core.off('LotteryStart', this.getLotteryStatus);
    this.core.off('LotteryEnd', this.handleLotteryEnd);
    this.core.off('UpdateInLottery', this.handleLotteryStatus);
  },
  methods: {
    async afterCoreInited() {
      // 获取旧版抽奖状态
      await this.getLotteryStatus();
      // 获取新版抽奖状态
      this.getDelayLotteryStatus();
      this.initCoreListeners();
    },
    strLen,
    // 组件显示时获取最新的定时抽奖状态
    getDelayLotteryStatus() {
      if (this.core) {
        this.core.getDelayLotteryStatus();
      }
    },
    // 初始话抽奖状态, 注册lotteryCore eventName事件
    initCoreListeners() {
      // 获取旧版版 抽奖状态
      this.core.on('LotteryStart', this.getLotteryStatus);
      // 获取新版 定时抽奖和即时抽奖 抽奖状态
      this.core.on('LotteryEnd', this.handleLotteryEnd);
      this.core.on('UpdateInLottery', this.handleLotteryStatus);
      if (this.lotteryProcess !== 'start') return;
      this.getCollectInfo();
      const prizeHis = get('prizeHis');
      if (prizeHis) this.historyPrize = prizeHis.split(',');
    },
    // 根据抽奖状态,显示对应动画
    handleLotteryStatus() {
      if (this.core.InLottery.status === 'running') {
        this.lotteryProcess = 'lotterying';
        this.lotteryId = this.core.InLottery.lotteryId || '';
        this.lotterying = true;
        this.fetchOverWinner = false;
        this.branchStatus = this.core.InLottery.branchStatus || false;
        this.getDelayStatus();
      } else if (this.core.InLottery.status === 'over') {
        this.lotteryProcess = 'lotterying';
        this.lotterying = false;
        this.branchStatus = this.core.InLottery.branchStatus || false;
        if (this.core.InLottery.lotteryId) {
          this.lotteryId = this.core.InLottery.lotteryId;
          this.getWinnersListBefore();
        }
      }
    },
    // 定时抽奖结束后，socket返回lotteryId
    handleLotteryEnd() {
      this.lotteryId = this.core.InLottery.lotteryId;
      if (this.branchStatus && this.core.InLottery.status === 'running') {
        this.lotterying = true;
        this.lotteryProcess = 'lotterying';
        return;
      }
      if (this.lotteryId && !this.branchStatus) {
        this.getWinnersListBefore();
      }
      this.lotterying = false;
    },
    // 初始化select选项中英文 文案
    initOptions() {
      this.lotteryRangeData = [
        {
          label: this.t('plvIA.lottery.missedUsers'),
          value: 'notWinning'
        },
        {
          label: this.t('plvIA.lottery.allOnlineUsers'),
          value: 'all'
        },
      ];
      this.modeOptions = [
        {
          label: this.t('plvIA.lottery.immediate'),
          value: 0
        },
        {
          label: this.t('plvIA.lottery.timed'),
          value: 1
        }
      ];
    },
    // 获取定时器倒计时
    async getDelayStatus() {
      const data = await this.core.getTimeLeft();
      this.delayTimeSecord = data.time;
      this.clearDelayTimer();
      // 判断组件是否隐藏，销毁和倒计时。
      if (this.delayTimeSecord > 0 && this.visible) {
        this.lotteryProcess = 'lotterying';
        this.lotterying = true;
        this.delayStatus = true;
        this.DelayTimer = setTimeout(this.getDelayStatus, 1000);
      }
    },
    // 清理定时器
    clearDelayTimer() {
      if (this.DelayTimer) {
        clearTimeout(this.DelayTimer);
        this.DelayTimer = null;
      }
    },
    // 计算毫秒数
    calcDelay() {
      const delay = new Date(this.luckyTime).getTime() - Date.now();
      this.delayTime = delay;
    },
    // 选择抽奖模式
    selectMode(index) {
      this.modeIndex = index;
    },
    // 切换新旧版本
    changeBranch() {
      this.branchStatus = !this.branchStatus;
    },
    debounce(method, delay = 500) {
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        method();
      }, delay);
    },
    optionFocus(refs) {
      this.$nextTick(() => refs.focus());
    },
    showTips(msg) {
      this.errorMsg = msg || this.t('plvIA.lottery.exceedWinners');
      this.errorTipsShow = true;
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.errorMsg = '';
        this.errorTipsShow = false;
      }, 3000);
    },
    getPrize(val) {
      if (val) {
        this.prize = val;
        this.wrongOptions.prize = false;
      }
    },
    selectRange(index) {
      this.lotteryRange = this.lotteryRangeData[index].value;
    },

    checkNumber(value) {
      if (Number(value) === 0) {
        this.wrongOptions.amount = true;
        this.$refs.numberSelect.setWrong();
        this.amount = '';
        return;
      }
      this.amount = value;
      this.wrongOptions.amount = false;
    },

    showMoreSetting(value) {
      this.showMore = value;
    },

    // 搜索在线昵称
    searchLists() {
      const { seachUser, lotteryRange } = this;
      this.debounce(async () => {
        if (seachUser && seachUser !== '') {
          const res = await this.core.searchLists(seachUser, lotteryRange);
          this.searchList = res;
        } else {
          this.searchList = [];
        }
      });
    },
    // 增加、删除自定义选项
    optionsControls(type, index) {
      if (type === 'add') {
        if (this.collectInfo.length === 3) return;
        this.collectInfo.push({
          field: '',
          tips: '',
          required: false
        });
        this.wrongOptions.custom.push({
          field: false,
          tips: false
        });
        if (this.collectInfo.length === 3) this.collectBtnList.custom.disable = true;
      } else {
        this.collectInfo.splice(index, 1);
        this.wrongOptions.custom.splice(index, 1);
        this.collectBtnList.custom.disable = false;
        this.checkCollectListLength();
      }
    },
    collectBtnControls(type, collectType, index) {
      if (collectType === 'custom') {
        this.optionsControls(type, index);
      } else {
        // 添加姓名或者手机号
        if (type === 'add') {
          const addStatus = this.collectBtnList[collectType].addStatus;
          if (!addStatus) {
            this.collectBtnList[collectType].addStatus = true;
          }
        } else if (type === 'del') {
          this.collectBtnList[collectType].addStatus = false;
          this.checkCollectListLength();
        }
      }
    },

    // 检查如果没有信息收集项，将中奖信息采集按钮关闭
    checkCollectListLength() {
      // 判断姓名和手机号是否收集
      if (this.collectInfo.length > 0) {
        return;
      }
      // 判断姓名和手机号是否收集
      if (!(this.collectBtnList.userName.addStatus || this.collectBtnList.userPhone.addStatus)) {
        this.collectSwitch = false;
      }
    },

    setCollectSwitch() {
      this.collectSwitch = !this.collectSwitch;
      // 开启信息收集开关后，没有收集项，默认显示手机和姓名
      const defaultCollect = this.collectSwitch && !this.collectBtnList.userPhone.addStatus && !this.collectBtnList.userName.addStatus && this.collectInfo.length === 0;
      if (defaultCollect) {
        this.collectBtnList.userName.addStatus = true;
        this.collectBtnList.userPhone.addStatus = true;
      }
    },

    // 更新预设列表
    updatePresetList(ary) {
      this.presetList = [];
      ary.forEach(item => {
        this.presetList.push(item.userId);
      });
    },
    async startLottery() {
      //   const sessionId = await utils.getSessionId(this.roomId);
      const { lotteryRange, prize, amount, collectInfo, presetList } = this;
      let fullInfo = [];
      if (this.collectSwitch) {
        if (this.collectBtnList.userName.addStatus) {
          fullInfo.push({
            type: this.collectBtnList.userName.type,
            field: this.t('plvIA.lottery.name'),
            tips: this.t('plvIA.lottery.enterName'),
            required: this.collectBtnList.userName.required
          });
        }
        if (this.collectBtnList.userPhone.addStatus) {
          fullInfo.push({
            type: this.collectBtnList.userPhone.type,
            field: this.t('plvIA.lottery.phoneNum'),
            tips: this.t('plvIA.lottery.enterPhoneNum'),
            required: this.collectBtnList.userPhone.required
          });
        }
        fullInfo = fullInfo.concat(collectInfo);
        if (fullInfo.length === 0) {
          this.$iaMessage.Lottery(this.t('plvIA.lottery.pleaseEntryCollect'));
          return;
        }
      }
      const options = {
        lotteryRange,
        prize,
        amount,
        sign: this.sign,
        preset: presetList.join(),
        collectInfo: JSON.stringify(fullInfo),
        ignoreOnline: true,
        delayTime: 0,
        hasCollect: this.collectSwitch ? 'Y' : 'N'
      };
      // 判断抽奖模式是 0即时抽奖 1定时抽奖
      if (this.modeIndex === 1 && this.branchStatus) {
        this.calcDelay();
        options.delayTime = this.delayTime;
      } else if (!this.branchStatus) {
        delete options.delayTime;
      } else {
        options.delayTime = 0;
      }
      const rightOptions = this.checkOptions(options);
      if (!rightOptions) return;
      this.options = options;
      if (await this.checkedUserCount()) {
        this.createLottery(this.options);
      }
    },
    // 检查聊天室的人数
    async checkedUserCount() {
      const { lotteryRange } = this;
      try {
        const res = await this.core.checkedUserCount(lotteryRange);
        if (res < this.amount) {
          this.toggleExceedConfirm(true);
          return;
        }
        this.wrongOptions.amount = false;
        this.totalAccount = res;
        return true;
      } catch (error) {
        this.$iaMessage.default(error.message || this.NETWORK_ERR);
      }
    },

    toggleExceedConfirm(toShow) {
      if (toShow) {
        this.$refs.exceedConfirm.show();
      } else {
        this.$refs.exceedConfirm.hide();
      }
    },

    // 创建抽奖
    async createLottery(options) {
      if (this.isFetchingStartApi || this.lotteryProcess === 'lotterying' || this.waitingFetchWinnners) {
        return;
      }
      this.isFetchingStartApi = true;
      // 数组为空时，传入空字符串
      if (JSON.parse(options.collectInfo).length === 0) {
        options.collectInfo = '';
      }
      try {
        const res = await this.core.createLottery(options);
        this.isFetchingStartApi = false;
        this.setCookie();
        this.lotteryId = res.lotteryId;
        this.lotteryProcess = 'lotterying';
        this.lotterying = true;
        this.fetchOverWinner = false;
        this.winnerList = [];
        // 清空预设名单
        this.presetList = [];
        this.page = 1;
        if (this.modeIndex === 1) {
          this.getDelayStatus();
        }
      } catch (error) {
        // alert(error);
        this.$iaMessage.default(error.message);
      }
      this.isFetchingStartApi = false;
      this.waitingFetchWinnners = false;
    },
    setCookie() {
      if (this.historyPrize.some(item => item === this.prize)) return;
      this.historyPrize.unshift(this.prize);
      if (this.historyPrize.length >= 10) {
        this.historyPrize = this.historyPrize.slice(0, 10);
      }
      set('prizeHis', this.historyPrize);
    },
    // 检查提交参数是否合规
    checkOptions(options) {
      const { prize, amount, collectInfo, delayTime } = options;
      if (!prize || prize === '' || strLen(prize) > this.maxLen.prize) {
        this.wrongOptions.prize = true;
        this.optionFocus(this.$refs.prize);
        return false;
      }
      if (delayTime < 0) {
        this.$iaMessage.default('抽奖时间不能小于当前时间');
        return false;
      }
      if (!amount || amount === '' || amount === 0) {
        this.wrongOptions.amount = true;
        this.$refs.numberSelect.setWrong();
        return false;
      }

      if (!this.liveStatus) {
        this.$iaMessage.default(this.t('plvIA.lottery.startLiveFirst'));
        return false;
      }

      const collectOptions = JSON.parse(collectInfo);
      let wrongOptins = false;
      let userIndex = 0; //  记录含有姓名和手机号选项
      // 校验
      for (let index = 0; index < collectOptions.length; index++) {
        // 获取真实下标 需要减去姓名和手机号选项index
        const realIndex = index - userIndex;
        const item = collectOptions[index];
        if (item.type) {
          userIndex++;
          continue;
        }
        if (
          item.field === '' ||
          strLen(item.field) > this.maxLen.collectionField
        ) {
          this.fieldOrTipsFocus(realIndex, true);
          this.wrongOptions.custom[realIndex].field = true;
          wrongOptins = true;
          break;
        }
        if (
          item.tips === '' ||
          strLen(item.tips) > this.maxLen.collectionTips
        ) {
          this.fieldOrTipsFocus(realIndex, false);
          this.wrongOptions.custom[realIndex].tips = true;
          wrongOptins = true;
          break;
        }
      }
      return !wrongOptins;
    },
    fieldOrTipsFocus(realIndex, isField) {
      const key = isField ? 'field' : 'tips';
      if (this.$refs.field[realIndex]) {
        this.optionFocus(this.$refs[key][realIndex]);
      } else {
        this.showMore = true;
        this.$nextTick(() => {
          this.optionFocus(this.$refs[key][realIndex]);
        });
      }
    },
    // 获取抽奖
    async getLotteryStatus() {
      const res = await this.core.getLotteryStatus();
      // 旧版抽奖getLotteryStatus才会有lotteryId
      if (res.lotteryId) {
        this.branchStatus = false;
        this.lotteryProcess = res.lotteryProcess;
        this.lotteryId = res.lotteryId;
        this.winnerList = res.winnerList;
        this.branchStatus = this.core.InLottery.branchStatus;
      }
      this.lotterying = true;
    },

    // 获取获奖名单
    async getWinnersList() {
      const { lotteryId, page, totalPages, allowRequest } = this;
      if ((totalPages != null && page > totalPages) || !allowRequest) return;
      this.allowRequest = false;
      this.waitingFetchWinnners = true;
      const res = await this.core.getWinnersList(
        Number.parseInt(page),
        lotteryId
      );
      this.isFetchingEndApi = false;
      this.allowRequest = true;
      this.lotterying = false;
      this.waitingFetchWinnners = false;
      this.$nextTick(() => {
        this.fetchOverWinner = true;
      });
      if (lotteryId !== this.lotteryId) return;
      this.totalPages = res.totalPages;
      this.page += 1;
      // this.winnerList = [...this.winnerList, ...res.contents];
      this.winnerList = this.winnerList.concat(res.contents);
    },
    // 新版即时抽奖和定时抽奖完成倒计时
    newTurnLottery() {
      this.lotteryProcess = 'start';
      this.core.endLottery();
      this.amount = '';
      this.lotteryRange = 'notWinning';
    },
    // 定时抽奖提前结束,二次清理抽奖状态
    delayEndLottery() {
      this.lotteryProcess = 'start';
      this.totalPages = null;
      //  清理抽奖状态
      this.core.endLottery();
    },
    // 旧版的清理
    resetLottery() {
      this.lotteryProcess = 'start';
      this.totalPages = null;
      this.core.resetInLottery();
      this.lotteryRange = 'notWinning';
    },
    // 旧版结束抽奖
    async oldEndLottery() {
      if (this.isFetchingEndApi) return;
      this.isFetchingEndApi = true;
      const data = await this.core.endLottery(this.lotteryId);
      this.prize = data.prize;
      this.getCollectInfo();
    },
    // 获取抽奖结果  清除抽奖状态
    async endLottery(breakdown) {
      const { lotteryId } = this;
      if (breakdown) {
        await this.core.endLottery(lotteryId);
        this.winnerList = [];
        this.lotterying = false;
        return;
      }
      // (调用完admin/endLottery接口后会调用另一个接口获取中奖名单，此时allowRequest===false，之后再隐藏抽奖中动画)
      if (
        this.isFetchingEndApi ||
        this.waitingFetchWinnners ||
        !this.allowRequest ||
        !this.lotterying
      ) {
        return;
      }
      // 定时抽奖中断后会没lotteryId，不执行后续操作
      if (!lotteryId && !breakdown) {
        this.winnerList = [];
        this.lotterying = false;
        this.core.endLottery();
        return;
      }
      this.delayStatus = false;
      await this.core.endLottery(lotteryId);
    },

    // 获取抽奖结果之后
    getWinnersListBefore() {
      this.prize = this.core.InLottery.prize || '';
      this.winnerList = [];
      this.page = 1;
      this.totalPages = null;
      this.allowRequest = true;
      this.getWinnersList();
      this.core.resetInLottery();
    },

    handleEnsureExceedConfirm() {
      this.toggleExceedConfirm(false);
      this.wrongOptions.amount = false;
      this.createLottery(this.options);
    },

    handleCancelExceedConfirm() {
      this.toggleExceedConfirm(false);
      this.wrongOptions.amount = true;
    },

    // 获取自定义用户信息
    async getCollectInfo() {
      const res = await this.core.getCollectInfo();
      const totalInfo = JSON.parse(JSON.stringify(res));
      // 如果没有自定义用户信息，默认显示手机号和姓名
      if (!totalInfo) {
        this.collectBtnList.userName.addStatus = true;
        this.collectBtnList.userPhone.addStatus = true;
        return;
      }
      this.collectBtnList.userName.addStatus = false;
      this.collectBtnList.userPhone.addStatus = false;
      // 过滤姓名和手机号
      this.collectInfo = totalInfo.filter(item => {
        // 兼容线上问题，匹配中英文姓名和手机号
        const nameRex = /^(姓名|Name)[:：]?$/;
        const phoneRex = /^(手机|Phone number)[:：]?$/;
        const isName = nameRex.test(item.field);
        const isPhone = phoneRex.test(item.field);
        if (isName) {
          this.collectBtnList.userName.addStatus = true;
          this.collectBtnList.userName.required = item.required === undefined ? true : item.required;
        } else if (isPhone) {
          this.collectBtnList.userPhone.addStatus = true;
          this.collectBtnList.userPhone.required = item.required === undefined ? true : item.required;
        } else {
          // 自定义默认情况 false
          item.required = item.required === undefined ? false : item.required;
        }
        return !(item.type || isName || isPhone);
      });
      this.wrongOptions.custom = [];
      this.collectInfo.forEach(() => {
        this.wrongOptions.custom.push({
          field: false,
          tips: false
        });
      });
    }
  }
};
</script>

<style lang="scss">
@import '../../assets/styles/main.scss';
.p-lottery__defalut__select {
  position: absolute;
}

.plv-ia-lottery input[type='text'] {
  color: #333;
  font-size: 14px;

  &::-webkit-input-placeholder {
    color: #9e9e9e;
  }
  &.plv-ia-wrong-input {
    border: 1px solid #ff5722 !important;
    background: #ffe9e9 !important;
    &::-webkit-input-placeholder {
      color: #333 !important;
    }
  }
}

.p-wrong-input::-webkit-input-placeholder {
  color: #333 !important;
}

.plv-ia-lottery {
  position: relative;
  color: #333;
  width: 100%;
  overflow: auto;
  margin: 0 auto;
  box-sizing: border-box;

  * {
    box-sizing: border-box;
  }
}

.plv-ia__lottery__start {
  display: flex;
  justify-content: center;
  padding-top: 24px;
  margin-left: 60px;
  position: relative;
  .plv-ia__lottery__containter {
    min-width: 550px;
  }
}

.plv-ia__lottery__aside__right {
  line-height: 18px;
  > span {
    position: relative;
    width: 70px;
    cursor: pointer;
    color: #2096f3;
    font-size: 14px;
    text-align: center;
    flex-shrink: 0;

    &:hover {
      opacity: 0.8;
    }

    &:active {
      opacity: 0.9;
    }
  }

  .plv-ia-lottery__msg__input {
    width: 320px;
    color: #aeaeae;
    padding: 0 8px;
    display: inline-block;
    line-height: 38px;
    border: 1px solid #cfd8dc;
    border-radius: 2px;
    background: #e9ecee;
  }

  > div > p {
    display: flex;
    margin-top: 20px;
    justify-content: space-between;
    color: #2c2c2c;
    font-size: 14px;

    > span {
      color: #2196f3;
      cursor: pointer;

      &:hover {
        opacity: 0.8;
      }

      &:active {
        opacity: 0.9;
      }
    }

    .lottery-add-disabled {
      cursor: not-allowed;
      color: #9e9e9e;
    }
  }

  .plv-ia-lottery__msg__list__container {
    margin-top: 20px;

    > li {
      width: 100%;
      margin-bottom: 20px;
      display: flex;
      position: relative;
      align-items: center;
    }

    > li:last-child {
      margin-bottom: 0;
    }

    .plv-ia-lottery__options__control {
      display: flex;
      align-items: center;
      line-height: 40px;
      cursor: default !important;
      font-size: 14px;
      padding-left: 8px;
      position: unset;
      color: inherit;

      .plv-ia-lottery__options__control-requiredText {
        margin-right: 7px;
      }
      .plv-ia-lottery__options__control__delete {
        margin-left: 17px;
        display: inline-block;
        width: 28px;
        height: 28px;
        background-image: url('./images/icon-recycle.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
        cursor: pointer;
        &:hover {
          opacity: 0.8;
        }
        &:active {
          opacity: 0.9;
        }
      }
    }
    .plv-ia-custom__list__input {
      & > input {
        &:hover,
        &:active {
          border: 1px solid #2196f3;
        }
      }
    }
  }

  .plv-ia-lottery__msg__name {
    width: 100px;
    height: 40px;
    margin-right: 6px;
    line-height: 40px;
    font-size: 14px;
    color: #2c2c2c;
    flex-shrink: 0;
    text-align: right;
  }

  @mixin collectionInput {
    height: 40px;
    position: relative;

    input {
      width: 100%;
      outline: none;
      line-height: 38px;
      padding: 0 8px;
      padding-right: 40px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(224, 224, 224, 1);
      border-radius: 2px;
    }
  }

  .plv-ia-lottery-collection-field {
    @include collectionInput;
    width: 100px;
    margin-right: 8px;
  }

  .plv-ia-lottery-collection-tips {
    @include collectionInput;
    width: 212px;
  }
}

.plv-ia-lottery-collection-inputlen {
  position: absolute;
  right: 0;
  top: 0;
  line-height: 40px;
  width: 40px;
  text-align: right;
  padding-right: 4px;
  font-size: 12px;
  color: #9e9e9e;
}

.plv-ia__search__group {
  position: relative;
}

.fast-search {
  width: 320px;
  margin-left: 0 !important;

  .plv-ia-search__icon {
    position: absolute;
    top: 0;
    right: 0;
    width: 40px;
    height: 40px;
    background: url(./images/icon-search.png) center no-repeat;
  }
}

.plv-ia__user__search__list {
  padding-left: 107px;
  max-height: 120px;
  overflow: auto;
}

.plv-ia-modal__center__form {
  position: relative;
  text-align: center;

  .plv-ia-modal__form__group {
    display: flex;
    align-items: center;
    position: relative;
    margin-bottom: 20px;
    text-align: left;
    font-size: 14px;
    &--branch {
      justify-content: flex-end;
      margin-bottom: 12px;
      font-size: 14px;
      color: #2196f3;
      position: relative;
      height: 16px;
      width: 430px;
    }
    > span:nth-child(1) {
      display: inline-block;
      width: 100px;
      margin-right: 8px;
      line-height: 0;
      vertical-align: middle;
      text-align: right;
      font-size: 14px;
    }

    > input {
      width: 320px;
      height: 40px;
      border: 1px solid rgba(207, 216, 220, 1);
      padding: 0 8px;
      vertical-align: middle;
      font-size: 14px;
      border-radius: 2px;
      outline: none;
      color: #333;

      &:hover,
      &:active {
        border: 1px solid #2196f3;
      }
    }

    .plv-ia-modal__form__input {
      padding-right: 50px;
    }

    .plv-ia__prize__length {
      position: absolute;
      left: 390px;
      font-size: 12px;
      display: inline-block;
      width: 30px;
      color: #9e9e9e;
    }
  }

  .plv-ia-modal__form__group--min {
    height: 20px;
    line-height: 20px;
  }

  .plv-ia-modal__form__input,
  .plv-ia-modal__form__select {
    width: 320px;
    height: 40px;
    padding-left: 8px;
    background-color: #fff;
    display: inline-block;
  }
  .plv-ia-modal__form__select {
    padding-left: 0;
    vertical-align: middle;
    border: none;
  }

  .plv-ia-modal__form__input__preset {
    padding-left: 8px;
    vertical-align: middle;
    outline: none;
    border: 1px solid #cfd8dc;
    font-size: 14px;
    &:hover,
    &:active {
      border: 1px solid #2196f3;
    }
  }

  .plv-ia-modal__form__input__sm {
    width: 320px;
    height: 40px;
    display: inline-block;
    vertical-align: middle;
  }
}
.plv-ia__lottery-btn-group {
  margin: 24px 0;
  // margin-bottom: 36px;
  text-align: center;
}

.plv-ia-lottery-btn {
  height: 32px;
  line-height: 32px;
  padding: 0 20px;
  background: #2196f3;
  font-size: 14px;
  color: #ffffff;
  border-radius: 18px;
  border: none;
  outline: none;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }

  &:active {
    opacity: 0.9;
  }
}

.plv-ia-lottery__tip__error {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  padding: 10px;
  text-align: center;
  font-size: 12px;
  color: #fff;
  background: #f86665;
}

.plv-ia-arrow__content {
  .p-arrow__bottom {
    position: absolute;
    top: 7px;
    right: -6px;
  }
  .p-arrow__bottom:before,
  .p-arrow__bottom:after {
    position: absolute;
    content: '';
    border-top: 5px #fff solid;
    border-left: 5px transparent dashed;
    border-right: 5px transparent dashed;
    border-bottom: 5px transparent dashed;
  }
  .p-arrow__bottom:before {
    border-top: 5px #adadc0 solid;
  }
  .p-arrow__bottom:after {
    top: -1px;
    border-top: 5px #fff solid;
  }

  .p-arrow__top {
    position: absolute;
    top: 1px;
    right: -6px;
  }
  .p-arrow__top:before,
  .p-arrow__top:after {
    position: absolute;
    content: '';
    border-top: 5px transparent dashed;
    border-left: 5px transparent dashed;
    border-right: 5px transparent dashed;
    border-bottom: 5px #fff solid;
  }
  .p-arrow__top:before {
    border-bottom: 5px #adadc0 solid;
  }
  .p-arrow__top:after {
    top: 1px;
    border-bottom: 5px #fff solid;
  }
}

.plv-ia-lottery-date-picker {
  width: 250px;
  .el-picker-panel__content {
    width: auto;
    margin: 4px 15px;
  }

  .el-date-table td {
    padding: 0;
  }

  .el-date-table td.disabled div {
    background: transparent;
    color: rgba(#000, 0.25);
  }

  .el-date-table td span {
    border-radius: 2px;
  }

  .el-date-table td.current:not(.disabled) span {
    background: #2196F3;
    color: #fff;
  }

  .plv-ia-qa-filter-date-choosed span {
    background: #E6F7FF;
    border-radius: 2px;
  }

  .el-date-table td.today:not span {
    border: 1px solid rgba(#2196F3, 0.8);
    color: rgba(#2196F3, 0.8);
    box-sizing: border-box;
  }

  .el-date-table td.today.end-date span,
  .el-date-table td.today.start-date span {
    color: #fff;
  }

  .el-date-table td div {
    padding: 0;
    height: 24px;
  }

  .el-date-range-picker__content {
    padding: 8px;
  }

  .el-date-picker__header {
    margin: 4px 12px 0;
  }

  .el-date-table th {
    line-height: 1.5;
  }
}
.plv-ia-modal__switch__btn {
  position: relative;
  display: inline-block;
  width: 32px;
  height: 20px;
  margin-top: -1px;
  border-radius: 16px;
  background: #2096f3;
  cursor: pointer;
  vertical-align: middle;
  &:before {
    content: '';
    position: absolute;
    top: 2px;
    right: 2px;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: #fff;
  }
}

.plv-ia-modal__switch__btn__off {
  background-color: #ccc;

  &:before {
    left: 2px;
    right: auto;
  }
}
.plv-ia__lottery-collect-switch {
  position: relative;
  justify-content: flex-start !important;
  span {
    margin-left: 18px;
  }
}

body[data-lang='en'] {
  .plv-ia-modal__center__form .plv-ia-modal__form__group > span:first-child {
    width: 120px;
  }
  .plv-ia__lottery__aside__right .plv-ia-lottery__msg__name {
    width: 120px;
  }
  .plv-ia__lottery__aside__right .plv-ia-lottery__msg__list__container .plv-ia-lottery__options__control {
    right: -3em;
  }
  .p-preset-content {
    left: 148px;
  }
  .plv-ia__user__search__list {
    padding-left: 148px;
  }
  .plv-ia__lottery-collect-handle {
    width: 450px;
  }
  .plv-ia-modal__form__group--branch {
    width: 450px;
  }
}

.plv-ia__lottery-collect-handle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  width: 430px;
  span {
    color: #2096f3;
  }
}
.plv-ia__lottery-add-option:hover {
  .plv-ia__lottery-add-option-model {
    display: block;
  }
}
.plv-ia__lottery-add-option {
  position: relative;
  height: 25px;
  line-height: 25px;
  .plv-ia__lottery-add-option-model {
    display: none;
    position: absolute;
    top: 25px;
    left: 50%;
    transform: translateX(-50%);
    text-align: left;
    padding: 13px 24px;
    z-index: 100;
    background: white;
    width: 120px;
    box-sizing: border-box;
    border: 0.5px solid #DCDCDC;
    border-radius: 2px;
    box-shadow: 0 -5px 5px -3px rgba(0, 0, 0, 0.1), 0 -8px 10px 1px rgba(0, 0, 0, 0.06);
  }
  li + li {
    margin-top: 20px;
  }
  li:hover {
    cursor: pointer;
    color: #3796F3;
    font-size: 14px;
  }
  .plv-ia__lottery-add-option-item--disable {
    color: #aeaeae !important;
    cursor: default !important;
  }
}

</style>
